import { React, useState, useContext,useEffect } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addMonthsToDateString,
       getFormattedDate,isEndDateGreater,
       changeDateFormat,getMonthRange
  } from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_URL } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { percentageVariationReportSheet } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

const UrbanPercentageVariation = () => {
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState('');
    const [reportType, setReportType] = useState('');
    const [groupType, setGroupType] = useState('');
    const [quater,setQuater] =useState('')
    const [yearName, setYearName] = useState('');
    const [isQuarter, setIsQuarter] = useState(false);
    const storedLanguage = localStorage.getItem('language');
    const [years, setYears] = useState([]);
    const [months, setMonth] = useState(
        [{ value: "Jan-Mar", label: "Jan-Mar" },
        { value: "Apr-Jun", label: "Apr-Jun" },
        { value: "Jul-Sep", label: "Jul-Sep" },
        { value: "Oct-Dec", label: "Oct-Dec" }]);
    const today = new Date();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

      //Get all Years Data
  useEffect(() => { 
    //Years
  const fetchYears = async () => {
      const currentYear = new Date().getFullYear();
      const endYear = 2019;
      const yearsArray = [];
    for (let year = currentYear; year >= endYear; year--) {
        yearsArray.push(`${year}`);
      }
       setYears(yearsArray);
    };
    fetchYears();
 }, []);


// Handle on change Event ********
const handleOnChange = (e) => {
  const { name, value } = e.target;
 switch (name) {
      case 'reportType':
          setReportType(value);
          break;
      case 'groupType':
          setGroupType(value);
         if(value==='LQ' || value==='LYQ'){
            setIsQuarter(true)
          }else{
            setIsQuarter(false)
          }
          
          break;
      case 'quater':
          setQuater(value);
          break;
      case 'yearName':
          setYearName(value);
          break;
      default:
          console.log('Case does not match');
  }
};



   
   
   
   //handle excel sheet ***************
const handleGenerateExcel = async() => {

        if(reportType===''){
        toast.error('Please select Report Type', messages.COLOR_RED);
            return
        }
        if(groupType===''){
         toast.error('Please select Percentage Variation', messages.COLOR_RED);
         return
        }

        if(isQuarter){
          if(quater===''){
            toast.error('Please select Quater', messages.COLOR_RED);
            return
          }
          if(yearName===''){
            toast.error('Please select Year Name', messages.COLOR_RED);
            return
          }
        
        }else{
          if (!startDate) {
            toast.error('Please select the date', messages.COLOR_RED);
            return;
        }
        }
       

     
     
        
        // let eDate=  endDate[0] + endDate.slice(1).toLocaleUpperCase();



    try {
    showLoading(true);
    let post_data='';
    // quater yearName
       if(groupType==='Month' || groupType==='LYM'){
        let sDate= getFormattedDate(startDate);
             post_data={
              fromDate: sDate,
              toDate: sDate,
              reportType: groupType, //not used
              groupType: groupType,
              priceReportType: reportType  //Region
            }
       }else{
              let month=quater.split('-')
              let year= yearName.toString().slice(-2);
                
            post_data={
              fromDate: `${month[0]} ${year}` ,
              toDate: `${month[1]} ${year}` ,
              reportType: groupType,
              groupType: groupType, //not used
              priceReportType: reportType //Region
            }
       }
        

        const response = await axios.post(`${API_URL}api/price/PercentageVariationSheetUrbanIndex`, post_data, config);
        const reportData = response.data;
        if(reportData.status){
            let allData= reportData.data.GroupCodes;
                downloadReport(allData,groupType,reportType,post_data.fromDate,post_data.toDate)
         }else{
          toast.error('Data is not found', messages.COLOR_RED);
        }
      
    } catch (error) {
    console.error(error);
    }finally{
    showLoading(false);
    }
   }

const formatGrossValue = (value,tofixed) => {
    if (value === 0) return "0.00";
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return "0.00";
    return Number(value).toFixed(tofixed);
};



   const downloadReport=(allData,groupType,reportType,fromDate,toDate)=>{

  let date=''
   if(groupType==='LQ' || groupType==='LYQ' ){  //Last Quarter,Last Year Quater
       date=`${fromDate}-${toDate}`;
   } else{
       date=`${fromDate}`;

   }





 let excelObjectData='';
   if(reportType==='Region'){ // Region Report ******************
         let sheetData = allData.map((item,index) => ([
            item.year,
            formatGrossValue( item.index_state,2),
            formatGrossValue(item.index_west,2),
            formatGrossValue(item.index_central,2),
            formatGrossValue(item.index_bundelkhand,2),
            formatGrossValue(item.index_east,2),
        ]));
         excelObjectData = {
          fileName:`RegionPercentageVariation_Urban_${groupType}(${date})`,
          sheetName: "percentageVariationReport",
          fileType: 'xls',
          firstRowMergeCells: "A1:F1",
          firstRowExportDate: changeDateFormat(new Date()),
          secondRowMergeCells: "A2:F2",
          secondRowText: `Percentage Variation Sheet Of Urban Index ${date} (Base Year 2011-12=100)`,
          thirdRowMergeCells: "A3:F3",
          thirdRowText: `${reportType} wise  % variations w.r.t.Month`,
          headerEnglishColumns:['State & Regions Qty','State','Western','Central', 'Bundelkhand',
            'Eastern'],
            excelRowData: sheetData
          };

    }else if(reportType==='Major Group'){  // Major Group Report  ******************  


          let sheetData = allData.map((item,index) => ([
            item.year,
            formatGrossValue(item.index,2),
            formatGrossValue(item.major1,2),
            formatGrossValue(item.major2,2),
            formatGrossValue(item.major3,2),
            formatGrossValue(item.major4,2),
            formatGrossValue(item.major5,2),
        ]));
        excelObjectData = {
          fileName:`MajorIndexPercentageVariation_Urban_${groupType}(${date})`,
          sheetName: "MajorIndexPercentageVariationRe",
          fileType: 'xls',
          firstRowMergeCells: "A1:G1",
          firstRowExportDate: changeDateFormat(new Date()),
          secondRowMergeCells: "A2:G2",
          secondRowText: `Percentage Variation Sheet Of Rural Index ${date} (Base Year 2011-12=100)`,
          thirdRowMergeCells: "A3:F3",
          thirdRowText: `Main Group of Commodities wise % Variations in Month`,
          headerEnglishColumns:['Months & Items','General Index','Food Prod,Beverages & Tobacco', 'Fuel &  Light',
            'Housing','Clothing & Footwear','Misc.'],
            excelRowData: sheetData
          };



    }else if(reportType==='Sub Group'){

      let sheetData = allData.map((item,index) => ([
        item.year,
        formatGrossValue(item.subGroup1,2),
        formatGrossValue(item.subGroup2,2),
        formatGrossValue(item.subGroup3,2),
        formatGrossValue(item.subGroup4,2),
        formatGrossValue(item.subGroup5,2),
        formatGrossValue(item.subGroup6,2),
        formatGrossValue(item.subGroup7,2),
        formatGrossValue(item.subGroup8,2),
        formatGrossValue(item.subGroup9,2),
        formatGrossValue(item.subGroup10,2),
        formatGrossValue(item.subGroup11,2),
        formatGrossValue(item.subGroup12,2),
        formatGrossValue(item.subGroup13,2),
        formatGrossValue(item.subGroup14,2),
        formatGrossValue(item.subGroup15,2),
        formatGrossValue(item.subGroup16,2),
        formatGrossValue(item.subGroup17,2),
        formatGrossValue(item.subGroup18,2),
        formatGrossValue(item.subGroup19,2),
        formatGrossValue(item.subGroup20,2),
        formatGrossValue(item.subGroup21,2),
        formatGrossValue(item.subGroup22,2),
        formatGrossValue(item.subGroup23,2)
       
    ]));
    excelObjectData = {
      fileName:`SubGroupIndexPercentageVariationReport_Urban_${groupType}(${date})`,
      sheetName: "SubGroupIndexPrcentageVariation",
      fileType: 'xls',
      firstRowMergeCells: "A1:H1",
      firstRowExportDate: changeDateFormat(new Date()),
      secondRowMergeCells: "A2:H2",
      secondRowText: `Percentage Variation Sheet Of Urban Index ${date} (Base Year 2011-12=100)`,
      thirdRowMergeCells: "A3:H3",
      thirdRowText: `Sub Groups of Commodities wise % Variations in Month`,
      headerEnglishColumns:['Months & Items','Cereals & Products','Pulses & Products',`Milk ,Milk products`,
        'Oil & Fats',`Meat, Fish & Eggs`,'Vegetables','Fruits & Dry fruits',`Sugar,Gur etc`,'Condiments &  Spices',
        'Prepared meal & refresment','Non-alchohlic beverages','Pan,supari & tabacco beverages','Fuel and ligh',
        'Housing','Clothing and bedding','Footwear','Education','Medical care','Recreation and amusement','Personal care and effects',
        'Household and requisties','Transport and comunication','Others'
      ],
        excelRowData: sheetData
      };


    }
percentageVariationReportSheet(excelObjectData)
  }


  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                <h4 className="page_heading">
                        <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.URBAN_PERCENTAGE_VARIATION_REPORT : priceTitle.en.URBAN_PERCENTAGE_VARIATION_REPORT }} />
                    </h4>
                    <div className="row align-items-center">
                        
                    <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                        <label>Select Report For </label>

                        <select  
                        name="reportType" 
                        className="form-select"
                        onChange={handleOnChange}
                        value={reportType}
                        >
                        <option value="" disabled>[---Select--]</option>
                        <option value="Region">Region</option>
                        <option value="Major Group">Major Group</option>
                        <option value="Sub Group">Sub Group</option>
                      </select>
                   </div>

                        
                    <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                        <label>Select Percentage Variation </label>

                        <select  
                        name="groupType" 
                        className="form-select"
                        onChange={handleOnChange}
                        value={groupType}
                        >
                        <option value="" disabled>[---Select--]</option>
                        <option value="Month">Monthly</option>
                        <option value="LYM">Last Year Month</option>
                        <option value="LQ">Last Quarter</option>
                        <option value="LYQ">Last Year Quater</option>
                      </select>
                   </div>
                    { isQuarter && 
                    <>
                    <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                    <label>Select Quarter </label>

                    <select
                      value={quater}
                      onChange={handleOnChange}
                      name="quater"
                      className="form-select"
                    >
                      <option value="" disabled>Select Quarter</option>
                      {months.map((quarter, i) => (
                        <option key={i} value={quarter.value}>
                          {quarter.label}
                        </option>
                      ))}

                    </select>
                  </div>

                    <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                      <label>Select Year</label>
                      <select
                        value={yearName}
                        onChange={handleOnChange}
                        name="yearName"
                        className="form-select"
                      >
                        <option value="" disabled>Select Year</option>
                        {years.map((ele, index) => (
                          <option key={index} value={ele}>
                            {ele}
                          </option>
                        ))}

                      </select>
                    </div>
                </>
                  }
                 { !isQuarter && 
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                        <label className="fw-bold h6">Select From Date</label>
                        <DatePicker
                            className="form-control calendar_icon"
                            selected={startDate}
                            onChange={(e)=>(setStartDate(e))}
                            dateFormat="MMM yyyy"
                            showMonthYearPicker
                            placeholderText="Select month"
                            name="startDate"
                            maxDate={today}
                        />
                    </div>

                }
               


                    <div className="col-xl-2 col-lg-4 mb-3">
                        <label className="w-100 d-none d-sm-block">&nbsp;</label>
                        <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                    </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</>
  )
}
export default UrbanPercentageVariation